import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function HeroSection() {
  return <section className="relative pt-32 pb-24 md:pt-44 md:pb-36 bg-gradient-to-b from-navy to-navy-dark overflow-hidden" data-id="element-129">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
      backgroundSize: '40px 40px'
    }} data-id="element-130" />

      <div className="max-w-[1200px] mx-auto px-6 md:px-12 relative z-10" data-id="element-131">
        {/* Desktop: two-column layout */}
        <div className="hidden lg:grid grid-cols-2 gap-20 items-center" data-id="element-132">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          ease: 'easeOut'
        }} className="flex flex-col items-center text-center" data-id="element-133">
            <div className="mb-8" data-id="element-134">
              <span className="inline-block font-heading font-bold text-[17px] text-gold uppercase tracking-[0.1em] border border-gold/40 rounded-[4px] px-5 py-2" data-id="element-135">
                Leadership Coaching & Development
              </span>
            </div>

            <h1 className="text-white text-[58px] leading-[1.1] mb-8 tracking-[-0.02em]" data-id="element-136">
              Leadership is complex, and often lonely.
            </h1>

            <p className="text-white/80 text-[18px] leading-[1.75] mb-12 max-w-[520px]" data-id="element-137">
              I help entrepreneurs, founding partners, and senior executives
              think clearly, align people, and turn vision into action through
              others, especially when strategy stalls and teams don't execute.
            </p>

            <div className="flex flex-row gap-4 mb-6" data-id="element-138">
              <Button variant="white" data-id="element-139">
                Schedule a Leadership Clarity Conversation
              </Button>
              <Button variant="accent" href="https://schallercoaching.com/lwca" data-id="element-140">
                Become a Leadership Coach
              </Button>
            </div>

            <p className="text-white/90 text-[14px] max-w-[480px] leading-relaxed" data-id="element-141">
              Whether you want a trusted thinking partner or want to develop
              coaching skills that multiply leadership, there is a clear path
              forward.
            </p>
          </motion.div>

          {/* Premium Photo with Decorative Frame */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.3,
          ease: 'easeOut'
        }} className="relative w-full max-w-[440px] ml-auto" data-id="element-142">
            <div className="absolute top-5 -right-5 w-full aspect-[3/4] rounded-lg border-2 border-gold/40" data-id="element-143" />
            <div className="absolute -top-3 -left-3 w-10 h-10 border-t-2 border-l-2 border-gold z-20" data-id="element-144" />
            <div className="absolute -bottom-3 -right-3 w-10 h-10 border-b-2 border-r-2 border-gold z-20" data-id="element-145" />
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden shadow-2xl shadow-black/30 z-10" data-id="element-146">
              <img src="https://cdn.magicpatterns.com/uploads/pgSyXxJAwqk2dafSjTJZL1/8184_-_Square.png" alt="Dr. Greg Schaller - Leadership Coach" className="w-full h-full object-cover object-top" data-id="element-147" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/20 via-transparent to-transparent" data-id="element-148" />
            </div>
          </motion.div>
        </div>

        {/* Mobile/Tablet: Title → Photo → Subtitle → Buttons */}
        <div className="flex flex-col items-center text-center lg:hidden" data-id="element-149">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          ease: 'easeOut'
        }} data-id="element-150">
            <div className="mb-6" data-id="element-151">
              <span className="inline-block font-heading font-bold text-[17px] text-gold uppercase tracking-[0.1em] border border-gold/40 rounded-[4px] px-5 py-2" data-id="element-152">
                Leadership Coaching & Development
              </span>
            </div>

            <h1 className="text-white text-[36px] md:text-[50px] leading-[1.1] mb-8 tracking-[-0.02em]" data-id="element-153">
              Leadership is complex, and often lonely.
            </h1>
          </motion.div>

          {/* Photo */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.3,
          ease: 'easeOut'
        }} className="relative w-full max-w-[320px] md:max-w-[380px] mx-auto mb-10" data-id="element-154">
            <div className="absolute top-4 -right-4 w-full aspect-[3/4] rounded-lg border-2 border-gold/40" data-id="element-155" />
            <div className="absolute -top-3 -left-3 w-10 h-10 border-t-2 border-l-2 border-gold z-20" data-id="element-156" />
            <div className="absolute -bottom-3 -right-3 w-10 h-10 border-b-2 border-r-2 border-gold z-20" data-id="element-157" />
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden shadow-2xl shadow-black/30 z-10" data-id="element-158">
              <img src="https://cdn.magicpatterns.com/uploads/pgSyXxJAwqk2dafSjTJZL1/8184_-_Square.png" alt="Dr. Greg Schaller - Leadership Coach" className="w-full h-full object-cover object-top" data-id="element-159" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/20 via-transparent to-transparent" data-id="element-160" />
            </div>
          </motion.div>

          {/* Subtitle + Buttons */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5,
          ease: 'easeOut'
        }} className="flex flex-col items-center" data-id="element-161">
            <p className="text-white/80 text-[16px] md:text-[18px] leading-[1.75] mb-10 max-w-[520px]" data-id="element-162">
              I help entrepreneurs, founding partners, and senior executives
              think clearly, align people, and turn vision into action through
              others, especially when strategy stalls and teams don't execute.
            </p>

            <div className="flex flex-col items-center gap-4 w-full sm:w-auto mb-6" data-id="element-163">
              <Button variant="white" className="w-full sm:w-auto" data-id="element-164">
                Schedule a Leadership Clarity Conversation
              </Button>
              <Button variant="accent" className="w-full sm:w-auto" href="https://schallercoaching.com/lwca" data-id="element-165">
                Become a Leadership Coach
              </Button>
            </div>

            <p className="text-white/90 text-[14px] max-w-[480px] leading-relaxed" data-id="element-166">
              Whether you want a trusted thinking partner or want to develop
              coaching skills that multiply leadership, there is a clear path
              forward.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}